export const RECOVER_PASSWORD = 'passwordRecovery:RECOVER_PASSWORD'
export const RECOVER_PASSWORD_SUCCESSFUL = 'passwordRecovery:RECOVER_PASSWORD_SUCCESSFUL'
export const RECOVER_PASSWORD_FAILURE = 'passwordRecovery:RECOVER_PASSWORD_FAILURE'

export const RESET_PASSWORD = 'passwordRecovery:RESET_PASSWORD'
export const RESET_PASSWORD_SUCCESSFUL = 'passwordRecovery:RESET_PASSWORD_SUCCESSFUL'
export const RESET_PASSWORD_FAILURE = 'passwordRecovery:RESET_PASSWORD_FAILURE'

export const CHANGE_TEMPORARY_PASSWORD = 'passwordRecovery:CHANGE_TEMPORARY_PASSWORD'
export const CHANGE_TEMPORARY_PASSWORD_SUCCESS = 'passwordRecovery:CHANGE_TEMPORARY_PASSWORD_SUCCESS'
export const CHANGE_TEMPORARY_PASSWORD_FAILURE = 'passwordRecovery:CHANGE_TEMPORARY_PASSWORD_FAILURE'
